import { PayloadAction } from '@reduxjs/toolkit';
import { PriceStrategy } from '@snap-types/models/enums';
import { defaultInternalState } from '@ui/features/quote-builder/state/utilities/default-state';

import { ExtraReducerBuilder } from '../../types/shared';
import { WritableQuoteBuilderStateType } from '../../types/state';
import { editSnapQuote } from '../endpoints/edit-snap-quote';
import { setNoLastWin } from '../utilities/common-issues';
import { transformSnapQuoteToStoreState } from '../utilities/transform-quote';

export function editSnapQuoteFulfilled(
  state: WritableQuoteBuilderStateType,
  action: PayloadAction<typeof editSnapQuote.Types.ResultType>,
) {
  // Assign the defaults first so that we can populate the Issues
  Object.assign(state, defaultInternalState);

  const { quote, quoteLineUuidsWithoutLastWins } =
    transformSnapQuoteToStoreState(action.payload);

  // @TODO - validate that PDF can be viewed.
  // It seems safe to assume that a valid quote can always be viewed, but we should verify

  // @TODO - we should update a few other fields here - isLoading, canViewPDF, dialog
  Object.assign(state, {
    ...quote,
  });

  for (const quoteLineUuid of quoteLineUuidsWithoutLastWins) {
    /**
     * @NOTE(shawk): Some quote lines (e.g. those with `UserImport` pricing)
     * will never have a last win, so they probably shouldn't have a warning
     *
     * @TODO(shawk): Refactor this when we move more PriceStrategy UI
     * configuration to a canonical source.
     */
    const priceStrategy = state.quoteLines[quoteLineUuid].priceStrategy;
    const skipNoLastWinStrategies: PriceStrategy[] = [
      PriceStrategy.UserImport,
      PriceStrategy.NewPartUserPrice,
      PriceStrategy.NewPart,
      PriceStrategy.NewPartUserCost,
    ];

    if (!skipNoLastWinStrategies.includes(priceStrategy)) {
      setNoLastWin(state, quoteLineUuid);
    }
  }

  // If the currently selected Market/Discount Code per the API response isn't on the limited list
  // of Site Codes, then we need to show ALL the Market/Discount Codes
  state.showAllDiscountCodes = Boolean(
    quote.discountCode &&
      quote.siteDiscountCodes?.length &&
      !quote.siteDiscountCodes.includes(quote.discountCode),
  );

  state.showAllMarketCodes = Boolean(
    quote.marketCode &&
      quote.siteMarketCodes?.length &&
      !quote.siteMarketCodes.includes(quote.marketCode),
  );
}

export function editSnapQuoteReducer(builder: ExtraReducerBuilder) {
  builder.addMatcher(editSnapQuote.matchFulfilled, editSnapQuoteFulfilled);
}
